
var getBasePath = function(filePath){
    let parts = filePath.split('/');
    parts.pop();
    return parts.join("/");
}

var basePath = getBasePath(__filename);

var split = function(str){
    if(str.indexOf("/") >= 0){
        return str.split("/");
    }else if(str.indexOf(".") >= 0){
        return str.split(".");
    }
    return [str];
}

/**
 * This registry is intended to expose our Javascript files to a global
 * namespace for non-webpack modules/files.
 */
class DoRegistry {

    constructor(ctx){
        this.ctx = window.domedia = window.domedia || {};
    }

    _target(parts){
        let targetNs = this.ctx;
        parts.forEach(function(name){
            if(name.trim() == "") return; //might have trailing delimiter or something
            if(!targetNs[name]) targetNs[name] = {};
            targetNs = targetNs[name];
        });
        return targetNs;
    }

    /**
     * Register an object into the domedia namespace.
     * @param {String} fileNameAndPath The file name and path or just the page.
     * @param {Object|Function|String} objOrName Either the object or the name of the object.
     *    Eg. register("some/file/path","MyName", myObj) -> window.domedia.some.file.path.MyName = myObj
     * @param {Object|Function} [Optional] obj If objOrName parameter is a string, then this should be the object.
     * @returns {DoRegistry} A reference to this object so you can chain register() calls.
     */
    register(fileNameAndPath, objOrName, obj){
        let parts = split(fileNameAndPath.replace(basePath,""));
        let name;

        if(!obj){
            obj = objOrName;
            name = parts.pop().split(".")[0];
        }else{
            name = objOrName;
            parts.pop();
        }

        let targetNs = this._target(parts);

        //set our last element to the provided object
        targetNs[name] = obj;

        return this;
    }

    /**
     * Get the object from registry.
     * @param path
     * @returns {*}
     */
    get(path){
        let parts = split(path);
        if(parts[0] === "domedia") parts.shift();
        return this._target(parts);
    }
}

//expose the register itself
let loader = new DoRegistry(window);
loader.register(__filename, loader);

export default loader;